import { QuizAnswer, QuizAnswerAnalytics } from '../components/molecules/quiz/Quiz';

/**
 * Randomize answers order
 * @param {QuizAnswer[]} array
 * @returns {QuizAnswer[]}
 */
export const shuffleQuizAnswers = (array: QuizAnswer[]): QuizAnswer[] => {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

/**
 * Get quiz end score in percentage
 * @param {QuizAnswerAnalytics[]} answers
 * @returns {number} between 0 and 100
 */
export const getQuizScore = (answers?: QuizAnswerAnalytics[]): number => {
  if (!answers) return 0;
  const questionsNumber = answers.length;
  const goodAnswersNumber = answers.filter(({ selectedAnswerIndex }) => selectedAnswerIndex === 1).length;
  return Math.floor((goodAnswersNumber / questionsNumber) * 100);
};
